import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function EggInAHoleSandwich() {
  return (
    <>
      <HeaderWithSearch />
      <main style={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
        padding: 0,
        margin: 0
      }}>
        <section className="recipe-hero-anim" style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "40vh",
          padding: "60px 0 20px 0"
        }}>
          <h1 className="recipe-title-anim" style={{ fontSize: "3rem", fontWeight: "bold", marginBottom: 12 }}>Egg in a Hole Sandwich</h1>
          <p style={{ fontSize: "1.3rem", color: "#333", marginBottom: 16 }}>A classic breakfast treat with an egg cooked inside a slice of buttered bread.</p>
          <span className="season-badge season-fall">🍂 Best in Fall</span>
          <ImageWithFallback src="/Egg_in_a_hole.jpg" alt="Egg in a Hole Sandwich" className="recipe-image-anim" style={{ width: 340, borderRadius: 24, boxShadow: "0 4px 32px rgba(0,0,0,0.10)", marginBottom: 24, marginTop: 16 }} />
        </section>
        <section className="recipe-columns-anim" style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 48,
          padding: "20px 0 0 0",
          maxWidth: 1200,
          margin: "0 auto"
        }}>
          <div style={{ flex: 1, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Ingredients</h2>
            <ul className="ingredient-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>2 slices of bread (preferably thick-cut)</li>
              <li>2 large eggs</li>
              <li>2 tbsp butter</li>
              <li>2 tbsp chopped tomato</li>
              <li>2 tbsp chopped onion</li>
              <li>2 tbsp chopped coriander</li>
              <li>1 inch piece of chocolate</li>
              <li>Salt and pepper to taste</li>
              <li>Optional: grated cheese for extra flavor</li>
            </ul>
          </div>
          <div style={{ flex: 2, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Instructions</h2>
            <ol className="instructions-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>Place the 2 slices of bread on top of each other and place a piece of chocolate between the bread in the center. Using a cookie cutter or a glass, make a hole .</li>
              <li>Heat 1 tbsp butter in a large skillet over medium heat. Place the circle of bread in the pan.</li>
              <li>Toast the bread for 1-2 minutes until golden brown.</li>
              <li>Carefully remove the circle of bread and set aside. Add another tbsp of butter to the pan.</li>
              <li>Place the 2 slices of of bread in the pan.</li>
              <li>Crack an egg into each hole. Add the tomatoes and the onion in the hole with the egg. Season with salt and pepper.</li>
              <li>Cook for 2-3 minutes until the bottom is golden, then carefully flip and cook for another 1-2 minutes.</li>
              <li>Add cheese if desired during the last minute of cooking. Serve immediately while hot!</li>
            </ol>
          </div>
        </section>
        <section style={{ maxWidth: 1200, margin: "0 auto", padding: "24px 24px 60px 24px", display: "flex", gap: 32, flexWrap: "wrap" }}>
          <div className="chef-tips-box" style={{ flex: 1, minWidth: 300, background: "#f8f9fa", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Use bread that's a day or two old — it holds its shape better than very fresh, soft bread.</li>
              <li>Keep the heat medium-low so the bread toasts golden without the egg white staying raw.</li>
              <li>Butter both sides of the bread for an extra-crisp, golden crust.</li>
              <li>Toast the cut-out circle alongside the sandwich for a bite-sized dipper.</li>
            </ul>
          </div>
          <div className="health-benefits-box" style={{ flex: 1, minWidth: 300, background: "#eef9f0", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Eggs are a complete protein and a great source of choline for brain health.</li>
              <li>Tomato and onion add vitamin C and antioxidants to a simple breakfast.</li>
              <li>A filling combination of protein and carbs that helps keep morning energy steady.</li>
              <li>Easy to lighten up with whole-grain bread and a light hand on the butter.</li>
            </ul>
          </div>
        </section>
      </main>
    </>
  );
}

export default EggInAHoleSandwich;
